module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sort2-86cae31807627d316c6695c7e101a0ac.svg";